import React from "react";

const PlanEditorContext = React.createContext(null);

export default PlanEditorContext;
